import React from 'react';
import { Button, ButtonSize } from './button';

export type ButtonPrimaryColors = 'dark' | 'primary-blurple';

type ButtonPrimaryProps = {
  children: React.ReactNode;
  color?: ButtonPrimaryColors;
  onClick?: () => void;
  href?: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  target?: string;
  type?: 'submit' | 'button';
  size?: ButtonSize;
};

export const ButtonPrimary = ({
  children,
  onClick,
  href,
  color = 'dark',
  className,
  disabled,
  type,
  id,
  target,
  size,
}: ButtonPrimaryProps) => (
  <Button
    color={color}
    onClick={onClick}
    {...(href ? { href, target } : { disabled, type })}
    className={className}
    id={id}
    size={size}
  >
    {children}
  </Button>
);
